import React, {useState} from 'react';
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {API_URL} from '../../common/params';
import Swal from 'sweetalert2';
import TextComponent from '../formikComponents/TextComponent';
import CheckboxComponent from '../formikComponents/CheckboxComponent';
import RadioList from '../formikComponents/RadioComponent/List'
import {isDev} from '../../common/util';

import s from './contacto.module.scss';

const AddContactSchema = Yup.object().shape({
    nombre: Yup.string()
        .trim()
        .max(255)
        .required('Nombre requerido.'),
    // apellidos: Yup.string()
    //     .trim()
    //     .max(255)
    //     .required('Apellidos es requerido.'),
    email: Yup.string()
        .trim()
        .max(255)
        .email('Debe introducir un email válido')
        .required('Email requerido.'),
    telefono: Yup.string()
        .trim()
        .max(15)
        .required('Teléfono requerido.'),
    cp: Yup.string()
        .trim()
        .max(10)
        .required('Código postal requerido.'),
    modeloPuerta: Yup.string()
        .trim()
        .required('Modelo requerido.'),
    rgpd: Yup.boolean()
        .oneOf([true], "Debe aceptar la política de privacidad y el aviso legal para continuar"),
})


const ClienteForm = () => {

    const [isSubmitting, setIsSubmitting] = useState(false);

    const puertas = [
        {
            label: 'PREMIUM',
            value: 'Premium',
            img: {
                src: 'https://www.tesa-puertasacorazadas.com/wp-content/plugins/tesa-formulario-puertas/assets/img/puertaPremium.jpg',
                alt: 'Puerta Acorazada Premium',
                style: s.img
            },
            description: {
                text: '+ regalo mirilla digital'
            },
            link: {
                href: 'https://www.tesa-puertasacorazadas.com/wp-content/uploads/2018/07/Ficha-t%C3%A9cnica-PREMIUM.pdf',
                text: 'Ver modelo',
                target: 'blank',
                style: s.link
            }
        },
        {
            label: 'AUTOMÁTICA',
            value: 'Automática',
            img: {
                src: 'https://www.tesa-puertasacorazadas.com/wp-content/plugins/tesa-formulario-puertas/assets/img/puertaAutomatica.jpg',
                alt: 'Puerta Acorazada Automática',
                style: s.img
            },
            description: {
                text: '+ regalo mirilla digital'
            },
            link: {
                href: 'https://www.tesa-puertasacorazadas.com/wp-content/uploads/2018/07/Ficha-t%C3%A9cnica-AUTOMATICA.pdf',
                text: 'Ver modelo',
                target: 'blank',
                style: s.link
            },
        },
        //todo falta email para la puerta bunker
        {
            label: 'BUNKER',
            value: 'Bunker',
            img: {
                src: 'https://www.tesa-puertasacorazadas.com/wp-content/plugins/tesa-formulario-puertas/assets/img/puertaBunker.jpg',
                alt: 'Puerta Bunker',
                style: s.img
            },
            link: {
                href: 'https://www.tesa-puertasacorazadas.com/wp-content/uploads/2022/04/Ficha-tecnica-Bunker.pdf',
                text: 'Ver modelo',
                target: 'blank',
                style: s.link
            }
        },
        {
            label: 'PACK PREMIUM <br /> Y BUNKER',
            value: 'Pack premium y bunker',
            description: {
                text: '+ regalo mirilla digital <br /> + regalo igualamiento de llaves'
            },
        },
        {
            label: 'PACK AUTOMÁTICA <br /> Y BUNKER',
            value: 'Pack automática y bunker',
            description: {
                text: '+ regalo mirilla digital <br /> + regalo igualamiento de llaves'
            },
        }
    ];

    const extras = [
        {
            label: 'Cilindro TK 100',
            value: 'Cilindro TK 100',
            img: {
                src: 'https://www.tesa-puertasacorazadas.com/wp-content/plugins/tesa-formulario-puertas/assets/img/cilindro-tk100.jpg',
                alt: 'Cilindro TK 100',
                style: s.img
            },
            link: {
                href: 'https://www.tesa-puertasacorazadas.com/wp-content/uploads/2018/08/tk100_web.pdf',
                text: 'Ver detalles',
                target: 'blank',
                style: s.link
            }
        },
        {
            label: 'Linus Smart Lock',
            value: 'Linus Smart Lock',
            img: {
                src: 'https://www.tesa-puertasacorazadas.com/wp-content/plugins/tesa-formulario-puertas/assets/img/linus.jpg',
                alt: 'Linus Smart Lock',
                style: s.img
            },
            link: {
                href: 'https://www.yalelock.es/es/yale/yalelock/smart-living/linus-smart-lock/',
                text: 'Ver detalles',
                target: 'blank',
                style: s.link
            }
        }
    ];

    const initialValues = {
        nombre: isDev ? 'Jesus' : '',
        // apellidos: isDev ? 'Yepes' : '',
        email: isDev ? 'jesus@goltratec.com' : '',
        telefono: isDev ? '123123123' : '',
        cp: isDev ? '12345' : '',
        modeloPuerta: '',
        extras: false,
        rgpd: isDev,
        newsletter: false,
        fecha: ''
    }

    return <div className={s.addContactForm}>
        <Formik
            initialValues={initialValues}
            isInitialValid={false}
            onSubmit={(values, {resetForm}) => {
                setIsSubmitting(true);

                values.rgpd = values.rgpd ? 1 : 0;
                values.newsletter = values.newsletter ? 1 : 0;
                // values.extras = values.extras && 'Cilindro TK 100';

                fetch(`${API_URL}clientes/get-form-data`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                    },
                    body: JSON.stringify({...values})
                })
                    .then(r => r.json())
                    .then(r => {
                        if(r.status)
                            Swal.fire('Gracias!', 'Hemos recibido su solicitud.', 'success')
                        else
                            Swal.fire('Lo sentimos!', 'Ha habido un error al procesar tu solicitud. Por favor, inténtalo más tarde.', 'error')

                    })
                    .catch(e => {
                        console.log(e)
                        Swal.fire(
                            'Error',
                            'Ha habido un error al mandar los datos. Por favor, reinicie el navegador e inténtelo de nuevo',
                            'error'
                        )

                    })
                    .finally(() => {
                        setTimeout(() => {
                            setIsSubmitting(false);
                            resetForm();
                        }, 1000)

                    })

            }}
            validationSchema={AddContactSchema}
        >
            {({errors, touched}) => (
                <Form>
                    <div className={s.col}>
                        <Field
                            name="nombre"
                            label="Nombre"
                            component={TextComponent}
                            type="text"
                        />
                    </div>

                    {/*<div className={s.col}>*/}
                    {/*    <Field*/}
                    {/*        name="apellidos"*/}
                    {/*        label="Apellidos"*/}
                    {/*        component={TextComponent}*/}
                    {/*        type="text"*/}
                    {/*    />*/}
                    {/*</div>*/}

                    <div className={s.col}>
                        <Field
                            name="email"
                            label="Email"
                            component={TextComponent}
                            type="text"
                        />
                    </div>

                    <div className={s.col}>
                        <Field
                            name="telefono"
                            label="Telefono"
                            component={TextComponent}
                            type="text"
                        />
                    </div>

                    <div className={s.col}>

                        <Field
                            name="cp"
                            label="Código postal"
                            component={TextComponent}
                            type="text"
                        />
                    </div>

                    <div className={s.col}>
                        <div className={s.panelHeading}>
                            Modelo*
                        </div>
                        <div className={s.panelBody}>
                            <Field
                                name="modeloPuerta"
                                component={RadioList}
                                items={puertas}
                                bootstrapCol={6}
                                error={errors.modeloPuerta !== undefined && touched.modeloPuerta}
                            />
                        </div>
                    </div>

                    <div className={s.col}>

                        <div className={s.panelHeading}>
                            Extras
                        </div>

                        <div className={s.panelBody}>
                            <Field
                                name="extras"
                                component={RadioList}
                                items={extras}
                                bootstrapCol={6}
                                error={errors.extras !== undefined && touched.extras}
                            />
                        </div>

                    </div>

                    <div className={s.col + ' ' + s.legal}>
                        <span className={s.separator}></span>
                        {/**todo confirmar enlace */}
                        <Field name="rgpd"
                               label="He leído y acepto la <a href='https://www.tesa-puertasacorazadas.com/politica-de-privacidad/' target='blank' >Política de Privacidad</a> y el <a href='https://www.tesa-puertasacorazadas.com/aviso-legal/' target='blank'>Aviso legal</a>."
                               component={CheckboxComponent}/>
                    </div>

                    <div className={s.col + ' ' + s.legal}>
                        {/**todo ver que hacer con el newsletter. Supongo que meter en la base de datos */}
                        <Field name="newsletter"
                               label="Permito a TESA ASSA ABLOY el uso de mis datos para recibir periódicamente contenidos y ofertas de valor que me ayuden a mejorar la experiencia con los productos y servicios en los que estoy interesado/a."
                               component={CheckboxComponent}/>
                    </div>

                    <div className={s.col + ' ' + s.text_right}>
                        <button type="submit" disabled={isSubmitting} className={s.btnSubmit}>
                            {isSubmitting ? 'Espere...' : 'ENVIAR >'}
                        </button>
                    </div>

                </Form>
            )}
        </Formik>
    </div>
}

export default ClienteForm;
